import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DvTextarea from '@/packages/ui/components/inputs/DvTextarea.vue';
import FileItemLoader from '@/packages/ui/components/files/FileItemLoader.vue';
import AutocompleteQuestionTags from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/inputs/AutocompleteQuestionTags.vue';
import CheckboxResponseType from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/inputs/CheckboxResponseType.vue';

import { EXTENSIONS } from '@/constants/filesExtensions';

import constants from './constants';

const { QUESTION_TYPES } = constants;

const QUESTION_TYPES_COMMON_SCHEMAS = [
  {
    name: 'name',
    label: 'Текст вопроса',
    value: 'name',
    rules: 'required',
    component: DvTextField,
    props: {
      placeholder: 'Введите название',
    },
  },
  {
    name: 'description',
    label: 'Дополнительная информация',
    value: 'description',
    component: DvTextarea,
  },
  {
    name: 'image',
    label: 'Изображение к вопросу',
    value: 'image',
    component: FileItemLoader,
    props: {
      hidePrependIcon: true,
      accept: EXTENSIONS.images.accept,
      maxFileSizeInKb: '5120',
    },
  },
  {
    name: 'tag',
    label: 'Тег вопроса',
    value: 'tag',
    component: AutocompleteQuestionTags,
  },
];

const QUESTION_TYPES_DATA = {
  [QUESTION_TYPES.text]: {
    id: QUESTION_TYPES.text,
    name: 'Текстовый',
    description: 'Развернутый письменный ответ',
    icon: '$ui-edit',
    schema: [
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
  },
  [QUESTION_TYPES.other]: {
    id: QUESTION_TYPES.other,
    name: 'Другое',
    description: 'Документ, изображение, ссылка',
    icon: '$ui-edit',
    schema: [
      {
        name: 'responseTypes',
        value: 'response_types',
        rules: 'required_select:1,some',
        component: CheckboxResponseType,
      },
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
  },
};

const QUESTION_TYPES_LIST = Object.values(QUESTION_TYPES_DATA);

export default {
  QUESTION_TYPES_DATA,
  QUESTION_TYPES_LIST,
};
